/*
 * Public API Surface of ng-tiny-url
 */

export * from './lib/ng-tiny-url.service';
export * from './lib/ng-tiny-url.module';
